import {createStore} from "vuex";
import api from "./api";

export default createStore({
    state() {
        return {
            partners: null,
            location: null,
            radius: null,
            categories: [],
        };
    },

    mutations: {
        setPartners(state, partners) {
            state.partners = partners;
        },

        setLocation(state, location) {
            state.location = location;
        },

        setRadius(state, radius) {
            state.radius = radius;
        },

        setCategories(state, categories) {
            state.categories = categories;
        },
    },

    actions: {
        async fetchPartners({commit, state}) {
            const zip = state.location ? state.location.zip : null;
            const categories = state.categories.filter(c => c !== null && c.id !== -1);

            commit('setPartners', await api.partners(zip, state.radius, categories));
        }
    }
});
